import { notification } from 'antd'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import ModalError from '../../components/atoms/ModalError'
import ModalSuccess from '../../components/atoms/ModalSuccess'
import PointItem from '../../components/atoms/PointItem'
import Spinner from '../../components/atoms/Spinner'
import Const from '../../constants'
import { payment } from '../../repositories/apiRepo'
import useAuth from '../../usecases/useAuth'
import FooterPointCharge from './FooterPointCharge'
import HeaderPointCharge from './HeaderPointCharge'

const PointCharge = () => {
  const { userProfile, refetch } = useAuth()
  const [isLoading, setIsLoading] = useState(false)
  const [searchParams] = useSearchParams()
  const paymentStatus = searchParams.get('payment')
  const error = searchParams.get('error')

  const [modal, setModal] = useState(paymentStatus || '')

  const closeModal = () => {
    localStorage.removeItem('point')
    setModal('')
  }

  const handlePayment = async (point: number) => {
    setIsLoading(true)
    const callbackURL = `${process.env.REACT_APP_FE_URL}/callback`

    const dataSubmit = {
      card_state: 2,
      callbackURL,
      point: point
    }
    try {
      const res = await payment(dataSubmit)
      if (res.data) {
        window.location.href = res.data.data.redirectURL
      }
    } catch (error: any) {
      if (error?.response?.data?.error?.message) {
        notification.error({
          message: `エラー発生しました`,
          description: error.response.data.error.message
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!paymentStatus) {
      localStorage.removeItem('point')
    } else {
      refetch()
    }
  }, [])

  const handlePaymentAgain = () => {
    const point = localStorage.getItem('point')
    if (point) {
      handlePayment(parseInt(point))
    }
  }

  return (
    <>
      <Spinner spinning={isLoading}>
        <div className='min-h-full'>
          <HeaderPointCharge />
          <div className='text-[#00D4FF] font-bold text-2xl'>
            <div className='flex justify-center'>ポイントチャージ</div>
          </div>
          <div className='sm:mx-20 mx-5 '>
            <div className='text-white divide-x-0  divide-y divide-solid divide-[#00D4FF]'>
              {Const.LIST_POINT.map(({ point, price }) => (
                <PointItem
                  point={point}
                  price={price}
                  key={point}
                  handlePayment={() => handlePayment(point)}
                />
              ))}
            </div>
          </div>
          <FooterPointCharge />
        </div>
      </Spinner>

      {modal === 'success' && !(!userProfile || isLoading) && (
        <ModalSuccess isModalOpen={true} closeModal={closeModal} />
      )}
      {modal === 'error' && !(!userProfile || isLoading) && (
        <ModalError
          message={error || ''}
          isModalOpen={true}
          closeModal={closeModal}
          onAgain={handlePaymentAgain}
        />
      )}
    </>
  )
}

export default PointCharge
